import React from "react";

const SVGLogo = (
  <svg version="1.0" viewBox="0 0 300 260" className="SVGLogo">
    <g>
      <path
        fill="#49D3FA"
        d="M114.2,153.5c-6.3,1.3-12.6,0.5-18.9,0.6c-6.9,0.1-13.8,0-20.8,0c-1.9,0-3.4-0.1-1.9-2.6
		c6.5-10.7,12.9-21.4,19.4-32.1c0.4,0.2,0.7,0.4,1,0.8c4,6.5,7.6,13.3,11.4,19.9c2.3,3.9,2.7,3.9,5.8,0.5c3.9-4.2,7-9.1,11-13.2
		c0.4-0.2,0.8-0.1,1.2,0.1c20,0.1,39.9,0.1,59.9,0.2c10.7,0,21.3,0,32,0c1.2,0,2.7-0.5,3.7,0.8c-0.6,0.7-1.3,0.9-2.1,1.1
		c-3.5,0.3-7,0.2-10.5,0.2c-7.5-0.2-15.1,0.3-22.6,0.1c-9.8-0.1-19.7,0.2-29.5-0.1c-3.2-0.5-5.9,0.6-8.5,2.6
		c-8.5,6.4-17.2,12.3-25.8,18.6C117.4,152,115.7,152.4,114.2,153.5z"
      />
      <path
        fill="#55DBFB"
        d="M185.3,77c4.9,8,9.8,16.1,14.8,24.1c1.2,2,0.7,2.5-1.5,2.5c-10,0-20,0-30.1,0c-2.1,0-3.1-1.3-4-2.8
		c-3.5-5.8-6.9-11.7-10.5-17.4c-0.9-1.4-1.1-3.5-3.4-3.6c0.5-3.2,3.3-4.3,5.5-5.9c4.8-3.4,9.7-6.8,15-10.7c-6,0-11.2,0-16.5,0
		c-1.9,0-3.9,0.3-5.6-0.8c-0.4-0.4-0.4-0.9-0.2-1.4c0.4-0.4,0.9-0.6,1.4-0.8c7.4-0.8,14.8-0.3,22.1-0.3c1.2,0,2.3,0.5,3.3,1.2l0.1,0
		c2.1,8-0.3,15.7-1.1,22.9C177.6,82,180.3,77.7,185.3,77z"
      />
      <path
        fill="#0292FE"
        d="M229.6,235.9c-24.9,0.1-49.7,0.1-74.6,0.2c-2.9,0-3-1-1.6-3c1.2-1.7,2.3-3.4,3.4-5.1
		c2.9-3.4,6.9-5.5,10.7-7.8c1-0.6,2.2-1,3.4-0.9c12.5,1,25.1-0.2,37.6,1.6c8.1,2.1,13.9,8,20.6,12.5
		C229.9,233.9,230.5,234.8,229.6,235.9z"
      />
      <path
        fill="#4DD5FB"
        d="M110.7,87.7c5.1-9,10.2-18,15.9-26.6c0.5-0.5,1-1.2,1.8-1.2c6.1,0.2,12.3-0.9,18.4,0.8
		c1.9,2.2,0,3.5-1.2,4.8c-3.3,3.5-6.8,7-10.3,10.3c-2.2,2.1-2.5,3.7,0.2,5.6c2.6,1.9,5.1,4,7.5,6.2c0.8,0.8,2,1.3,1.5,2.8
		c-4.1,6.8-8.2,13.7-12.3,20.5c-4,2.1-7.5,0-10.8-1.7c-2.3-1.2-1.4-3.5-0.7-5.5c2.5-7.3,5-14.7,8.1-22.5c-5.2,2.4-9.3,5.2-13.9,7.1
		C113.5,88.7,111.6,90.8,110.7,87.7z"
      />
      <path
        fill="#2FBEFD"
        d="M209.2,221.8c-12.7-0.5-25.5-1.1-38.2-1.6c-1.6-0.1-2.8,0.8-4,1.6c-3.3,2.1-6.5,4.6-10.2,6.2
		c2.9-6.2,6.9-11.7,10.2-17.6c1.2-2.2,3.3-1.7,5.1-1.7c17.2,0,34.3,0,51.5,0c1.5,0,3.3,0.7,4.5-1c1.3,0.2,1.1,1.1,0.8,2
		c-4.1,3.7-8.7,6.8-12.9,10.4C214.1,221.6,211.9,222.8,209.2,221.8z"
      />
      <path
        fill="#15A5FE"
        d="M209.2,221.8c5.8-0.4,8.6-5.6,13.1-8.2c2.2-1.3,3.8-3.6,6.5-4.2c1.1-1,2.4-1,3.7-0.6
		c12.8,3.8,25.8,7.2,38.3,12.1c0.7,0,1.3,0.2,1.4,1.1c-0.6,2.4-2.9,3.2-4.7,4.3c-5.5,3.4-11.2,6.3-16.5,9.8c-1.2,0-2.4,0-3.6,0
		c-5.3-4.6-8.3-11-12.6-16.4c-1.5-2-2.9-4.1-4.5-6.2c0.8,6.3,1.2,12.6,2,18.9c0.2,1.3,0.1,2.7-0.9,3.7c-0.6,0-1.2,0-1.8,0
		c-3-4.7-8.5-6.3-12.5-9.8C214.8,224.2,212.1,222.9,209.2,221.8z"
      />
      <path
        fill="#48D2FA"
        d="M151.4,128.7c10.4,0,20.8,0,31.2,0c-0.7,4.4-5,5.9-7,9c6.8-2.1,13.5-5.2,20.5-7.6c1.9-0.6,4.8-2.1,5.7-0.4
		c1.1,2.2-1.9,3.2-3.6,4.2c-10.5,6.5-20.6,13.8-31.5,19.7c-16.6-0.1-33.2-0.1-49.8-0.2c0.4-2.7,2.8-2.2,4.4-2.6
		c7.2-1.8,14.5-2.9,21.7-4.5c3.6-0.8,5-2.5,4.8-6.1c-0.2-2.6-0.2-5.3,0.1-8c0.1-1.2,0.2-2.5,1.5-3c1.5-0.5,2.1,0.8,2.8,1.7
		c3.7,5,6.6,10.5,10,15.7c0.7,1.1,1.1,2.9,2.5,2.9c1.8,0,1.8-2.1,2.5-3.3c1.9-3.3,1.3-5.7-2.3-7.5c-3.6-1.7-6.7-4.3-10.2-6.2
		C152.9,131.7,151.3,130.8,151.4,128.7z"
      />
      <path
        fill="#8EE9F6"
        d="M110.7,87.7c1.6,1.7,2.7,0,3.8-0.6c5.1-2.5,10.1-5.3,16.1-8.4c-3.2,9.1-5.9,17.3-9.1,25.3
		c-1.4,3.5-0.8,4.7,2.8,5.4c2.6,0.5,5,1.7,7.7,1.5c-3.2,5.6-6.4,11.1-9.6,16.7c-0.4,0-0.7,0.1-1.1,0.1c-0.7,0.6-1.6,0.6-2.5,0.4
		c-8-1.9-15.9-4-23.8-6.4c-1.2-0.3-2-1.1-3-1.8c0-0.2-0.1-0.4-0.1-0.6c0.3-0.5,0.5-1.1,0.8-1.6c7.3-2.7,14.5-5.6,21.7-8.4
		c3.3-1.3,3.4-2.8,1.6-5.6c-2.7-4.3-6.2-8.2-7.2-13.5C109.5,89.5,110.1,88.6,110.7,87.7z"
      />
      <path
        fill="#35C4FD"
        d="M75.1,208.4c-0.6,1.6-1.2,3.1-2.6,4.2c-2.7,0.5-4.7,2.2-7,3.5c-2.6,1.5-4.6,1.2-6.3-1.6
		c-1.6-2.8-3.5-5.5-5.2-8.2c-1.5-2.4-3.1-2.8-5.3-0.7c-1.6,1.5-3.4,2.9-5.1,4.2c-1.6,1.2-3.2,2.9-5.5,1.3c5.6-10,11.1-20,17.4-29.5
		c2.1,0.9,1.4,2.7,1.1,4.2c-0.7,3.3-1.2,6.7-2.5,10.7c4.9-6.5,10-11.9,14-18.2c1.2,0,2.4,0,3.5,0c4.6,4.5,9.6,8.7,13.2,14.2
		c-0.2,1.1-0.7,2-1.6,2.7c-8.8,1-17.1,4-26.7,6c5.4,1.8,9.8,3.2,14.2,4.8C72.3,206.5,74.1,206.8,75.1,208.4z"
      />
      <path
        fill="#26B6FD"
        d="M166.7,153.6c4.2-4.6,10.1-6.9,15.1-10.4c6.5-4.5,13.2-8.6,19.9-12.9c-0.2-0.3-0.3-0.7-0.5-1
		c-9.5,3.5-19,7.1-29.8,11.1c4.3-4.6,7.7-8.2,11.2-11.8c7.6,0,15.2,0,22.9,0c0.8,2.6-0.5,4.9-1.3,7.1c-1.6,4.8-3.2,9.6-4.9,14.5
		c-0.9,1.2-0.4,3.5-2.9,3.4C186.6,153.6,176.7,153.6,166.7,153.6z"
      />
      <path
        fill="#27B6FD"
        d="M151.4,128.7c4.6,4.5,10.6,6.9,15.9,10.3c2.6,1.7,3.1,2.9,1.7,5.5c-1.4,2.5-1.7,7.2-4,7.3
		c-2.9,0.2-3.6-4.4-5.2-6.8c-3.3-5-6.4-10.2-10.1-16.1c-1.3,4.7-0.9,8.5-0.6,12.2c0.2,4-1.2,5.6-5.1,6.3c-8.4,1.4-16.7,3.4-25,5.2
		c-0.7,0.1-1.3,0.6-1.9,0.9c-0.9,0-1.8,0-2.7,0c7.6-6.7,16.3-11.9,24.4-18c2.2-1.7,4.7-3,6.8-4.9
		C147.2,128.8,149.2,128.4,151.4,128.7z"
      />
      <path
        fill="#27B7FD"
        d="M243.8,173c0.4,0.8,0.7,1.7,1.1,2.5c0.5,1.8-1,2.3-2,2.9c-5.6,3.8-10.9,7.9-16.5,11.7
		c-2.1,0.3-3.2-1.3-4.4-2.5c-4.1-3.8-7.8-8.1-12-11.7c-0.9-0.7-1.5-1.6-1.7-2.8c-0.3-0.5-0.3-0.9,0-1.4c1.2-1.6,3-1.8,4.7-2
		c5.1-0.7,10.1-1.8,15.1-2.2C233.6,168.5,238.2,172.1,243.8,173z"
      />
      <path
        fill="#0192FE"
        d="M67.5,220c-1.8,5.3-5.6,9.6-8.2,14.5c-0.7,1.4-1.9,1.6-3.3,1.6c-9.8,0-19.7-0.1-29.5,0
		c-3.1,0-2.8-1.1-1.3-3c7.8-2.2,14.6-6.9,21.9-10.2c4.4-2,8.5-4.6,13.1-6.2C63.2,216.9,65.5,218,67.5,220z"
      />
      <path
        fill="#28B7FD"
        d="M270.8,220.8c-6.3-0.1-11.9-3.2-17.8-4.7c-7-1.8-13.8-4.2-20.7-6.2c-1.1-0.3-2.3-0.3-3.5-0.5
		c-0.2-0.6-0.4-1.1-0.6-1.7c-0.1-0.3-0.2-0.6-0.4-0.9c-1.2-5.1-3.5-10.1-2.3-15.6c2.4-2.3,4.1,0,5.6,1.2c4.9,3.8,9.8,7.5,14.9,11
		c7.9,5.6,16.1,10.8,24.5,15.8C270.6,219.7,270.7,220.2,270.8,220.8z"
      />
      <path
        fill="#6BDCF6"
        d="M147.1,62c-2.5-1.8-5.3-0.7-8-0.9c-4.2-0.2-8.4-0.1-12.6-0.1c5.4-10.4,11.7-20.3,17.8-30.2
		c1.7-0.1,1.9,1.2,2.1,2.3c1.3,9.3,2.4,18.6,2.5,27.9c0,0.3,0,0.6,0,0.9c-0.2,0.3-0.5,0.4-0.9,0.5C147.6,62.5,147.3,62.3,147.1,62z"
      />
      <path
        fill="#36C4FD"
        d="M208.4,172c0,0.4-0.1,0.7-0.1,1.1c-3.9-6.5-7.8-13-11.7-19.4c1.7-0.7,0.6-2.9,2-3.7
		c0.6,0.1,1.1,0.4,1.6,0.8c5.2,0.5,9.6-2.3,14.5-3.1c4-0.6,7.7-3.1,12-1.7c1.4,1.8-0.2,3.1-1.1,4.2C219.8,157.3,214.5,165,208.4,172
		z"
      />
      <path
        fill="#58DCFB"
        d="M108.9,90.4c3.1,5,6.2,9.9,9.2,14.9c0.8,1.4,1.8,2.9-0.6,3.8c-7.9,3.1-15.8,6.2-23.7,9.3
		c-0.2,0.1-0.7-0.5-1-0.7C98.2,108.7,103.6,99.5,108.9,90.4z"
      />
      <path
        fill="#88E8F8"
        d="M148.9,61.1c-2.6-6.2-1.8-12.8-2.6-19.3c-0.5-3.7-0.5-7.5-1.9-11c0.3-0.6,0.6-1.1,1-1.7
		c6.3,2.2,10.9,7.1,16.2,10.7c0.8,0.6,1.4,1.5,2.5,1.6c1,0.7,1.3,1.7,1.6,2.8C161,50.8,155.3,56.3,148.9,61.1L148.9,61.1z"
      />
      <path
        fill="#27B7FD"
        d="M227,146.3c-8.2,0.6-15.9,3.6-23.8,5.6c-1.2,0.3-3.7,2.8-3.8-1.1c-0.4-1,0.1-1.7,0.7-2.4
		c5.5-6.5,10.1-13.8,16.3-19.7c0.5,0,1,0,1.5,0c3.4,5.9,6.8,11.7,10.2,17.6c-0.1,0.1-0.2,0.3-0.3,0.4
		C227.6,146.7,227.3,146.6,227,146.3z"
      />
      <path
        fill="#48D2FA"
        d="M148,62c0.3,0,0.6,0,0.9,0c8,0,16,0,25.2,0c-7.9,7.1-16.5,11.4-23.4,17.8c-1.5,3.1-3.2,6.1-5.4,8.7
		c-1,0.1-1.4-0.6-1.3-1.3C145.1,78.8,144.4,70,148,62z"
      />
      <path
        fill="#15A6FD"
        d="M60.1,217.3c-10.2,6.1-21.1,10.7-31.6,16.2c-1.3,0.7-2.2,0.1-3.3-0.4c3.3-5.6,6.6-11.2,9.9-16.8
		c1.5-2.1,3.7-2.4,5.9-2.1c4.8,0.6,9.7,0.8,14.5,0.9C57.4,215.2,59.2,215.4,60.1,217.3z"
      />
      <path
        fill="#35C3FD"
        d="M270.4,219.1c-1.8,1-3-0.3-4.3-1.2c-12.2-7.9-24.6-15.6-35.8-25c-1.2-1-2.4-2.2-4.2-2.2
		c-0.2-0.2-0.3-0.4-0.2-0.5c0-0.2,0.1-0.3,0.2-0.3c4.1-4.8,9.8-7.4,14.6-11.3c1.4-1.1,2.8-2.1,4.2-3.1c0.8,0.3,1,0.9,0.9,1.6
		c2.2,4.9,0.3,9.8,0.3,14.7c0,2.5-1.3,6.1,0.9,7.4c1.8,1.1,3.7-2.2,5.8-3.3c1.2-0.6,2.2-1.4,3.6-1.6
		C261.3,202.4,266.4,210.5,270.4,219.1z"
      />
      <path
        fill="#28B7FD"
        d="M60.1,217.3c-0.8-0.3-1.6-0.8-2.5-0.8c-6-0.2-11.9,0.2-17.8-0.9c-1.6-0.3-3.2,0.1-4.7,0.8
		c1-1.8,2-3.5,3-5.3c4.9-0.1,7.2-4.4,10.4-7c2.8-2.2,4.1-1.9,5.8,0.7c1.9,3,4.1,5.8,5.7,8.9c1.4,2.8,2.9,2.8,5.2,1.3
		c1.9-1.2,3.8-2.2,5.8-3.3c0.8-0.5,1.4-0.3,1.5,0.7c-1.9,2.3-2.7,5.4-5,7.4C64.4,220.8,63.2,216.7,60.1,217.3z"
      />
      <path
        fill="#6BDCF6"
        d="M148.9,61.1c5.2-6,10.9-11.5,16.8-16.8c3.5,5.4,7.1,10.9,10,16.7C166.7,61.1,157.8,61.1,148.9,61.1z"
      />
      <path
        fill="#0292FD"
        d="M251,235.9c1.8-3.8,5.9-4.5,8.9-6.6c4-2.7,8.2-5.1,12.3-7.6c3.2,4.2,5.5,8.9,8.5,14.1
		C270.4,235.9,260.7,235.9,251,235.9z"
      />
      <path
        fill="#8EE9F6"
        d="M148,62c-1.1,8.3-2.1,16.6-3.2,25c-0.1,0.6-0.1,1.1,0.4,1.6c0.2,0.8-0.1,1.4-0.8,1.9
		c-3.6-3.1-6.9-6.5-10.7-9.1c-3.1-2.1-2.2-3.3-0.2-5.3c4.6-4.6,9.1-9.3,13.6-13.9C147.4,62,147.7,62,148,62z"
      />
      <path
        fill="#0192FD"
        d="M231.4,235.9c-0.8-8.3-1.6-16.5-2.6-26.2c7.1,9.1,13,17.4,18.5,26.2C242.1,235.9,236.8,235.9,231.4,235.9z"
      />
      <path
        fill="#15A6FD"
        d="M75.1,208.4c-6.9-2.2-13.9-4.5-20.9-6.7c0.6-1.8,2.1-1.7,3.2-2c6.9-1.8,13.8-3.6,20.8-5.1
		c1.5-0.3,3.5-1.8,4.8,0.5C80.9,199.8,78.2,204.3,75.1,208.4z"
      />
      <path
        fill="#36C4FD"
        d="M243.8,173c-3.2,2-5.5-0.9-8.2-1.6c-2.4-0.6-4.3-2.5-6.9-2.9c-2.1-7.3-3.3-14.6-1.1-22.1
		c0.2-0.1,0.3-0.2,0.5-0.3C233.7,154.9,238.9,163.9,243.8,173z"
      />
      <path
        fill="#15A6FD"
        d="M84.8,192.5c-4.8-4.3-9.8-8.4-13.2-14.2c6.1-0.1,12.3,0,18.4-0.2c2.3-0.1,3,0.5,1.7,2.7
		C89.4,184.6,87.1,188.6,84.8,192.5z"
      />
      <path
        fill="#28B7FD"
        d="M256.2,194.4c-2.5,3-6,4.9-9.2,7c-2.7,1.8-2.2-0.9-2.3-2.4c-0.6-7.3,1.2-14.6,1-21.9
		C250.1,182.3,253.1,188.4,256.2,194.4z"
      />
      <path
        fill="#0392FD"
        d="M226,189.9c0,0.3,0,0.5,0.1,0.8c0,4.4,0.8,8.7,1.8,12.9c0.2,1,1.4,2.1-0.1,3.1
		c-5.9-10.3-11.9-20.6-17.8-30.9c1.8-1.5,2.2,0.7,2.9,1.3C217.3,181.3,221.7,185.6,226,189.9z"
      />
      <path
        fill="#15A6FD"
        d="M68.1,178.3c0.6,3.5-2.3,5-4,7.2c-3.4,4.3-6.8,8.6-10.9,13.8c-0.2-6.9,3.4-12,2.3-17.7
		c0.7-2.7,2.3-3.8,5.1-3.5C63.1,178.3,65.6,178.2,68.1,178.3z"
      />
      <path
        fill="#47D2FA"
        d="M164,41.5c-1.1,1.1-1.9,0.1-2.6-0.5c-5.4-3.9-10.7-7.9-16.1-11.9c1.3-2.3,2.6-4.6,3.8-6.9
		c1.2-2.4,2.1-2.3,3.4,0C156.3,28.7,160.2,35.1,164,41.5z"
      />
      <path
        fill="#8DE9F7"
        d="M185.3,77c-3.7,2.8-7.4,5.6-11.7,8.9c0.7-8.8,1.4-16.8,2-24.9C178.9,66.4,182.1,71.7,185.3,77z"
      />
      <path
        fill="#27B6FD"
        d="M92.1,120c9.8,2.6,19.5,5.1,29.3,7.7c-3.3,6.3-8.6,11.1-12.8,16.6c-1.7,2.2-2.7,0.1-3.5-1.3
		C100.7,135.4,96.4,127.7,92.1,120z"
      />
      <path
        fill="#46D1FA"
        d="M216.4,128.6c-4.4,7.4-10.3,13.7-15.7,20.4c-0.5,0.6-0.9,1.2-1.3,1.7c-0.3-0.3-0.6-0.6-0.9-0.9
		c2.3-7.1,4.7-14.1,7-21.2C209.2,128.6,212.8,128.6,216.4,128.6z"
      />
      <path
        fill="#26B6FD"
        d="M76.9,152.7c5.5-1.2,11-2.4,16.5-3.6c2.7-0.6,5.5-1.2,8.2-1.6c1.2-0.2,2.4-0.3,3.5-0.2
		c3,0.3,5.5,2.8,5.6,4.9c0.1,2.4-3.2,1.2-5,1.2c-9.6,0.1-19.2,0.1-28.8,0.1C77,153.1,77,152.9,76.9,152.7z"
      />
      <path
        fill="#0192FD"
        d="M227.7,146.4c0.4,7.4,0.7,14.7,1.1,22.1c-6.8,1.1-13.7,1.6-20.3,3.5c2.7-6.4,7.9-11,11.8-16.6
		c2.1-3.1,4.6-6,6.9-9C227.3,146.3,227.5,146.4,227.7,146.4z"
      />
      <path
        fill="#36C4FE"
        d="M243.9,191.9c0.2,2.5,0.1,6-1.6,6.9c-1.8,0.9-4.3-1.7-6.3-3.1c-0.8-0.6-1.5-1.4-2.3-2
		c-5.1-3.7-5.3-3.9-0.4-7.6c2.7-2.1,6.1-6.1,8.7-5.1c2.5,1,1.2,6.3,2,9.6C243.9,191,243.9,191.4,243.9,191.9z"
      />
      <path
        fill="#36C4FE"
        d="M264,213c-5.2-2.1-10-4.1-14.1-7.6c-1.7-1.5-2.1-2.6,0.1-3.5c2.1-0.9,3.2-6.2,6.3-2
		C259.3,203.9,261.4,208.6,264,213z"
      />
    </g>
  </svg>
);

export default SVGLogo;



// WEBPACK FOOTER //
// ./src/components/Intro/SVGLogo.js